// export layout related constants
export const LAYOUT_VERTICAL = 'vertical';

export const LAYOUT_HORIZONTAL = 'horizontal';

export const LAYOUT_WIDTH = 'scrollable';

export const SIDEBAR_TYPE = 'dark';

export const TOPBAR = 'light';

export const LAYOUT_MODE = 'light';
